<template>
    <div id="app">
        <header v-show="logged">
            

            <img id="logo" ref="logo" :src="$url + 'img/logo.png'">


            <nav v-if="logged" id="nav" v-bind:class="{ menu_icon_margin: menu_active }">
                <div class="menu-icon" id="menu-icon" ref="menu-icon" v-bind:class="{ menu_icon_active: menu_active }" v-on:click="menuHandler">
                    <ul>
                        <li><img :src="$url + 'img/x1/perfil_0' + avatar + '.png'"></li>
                        <li ref="name_user" v-html="menu_info"></li>
                    </ul>
                </div>
                <ul v-if="menu_active" v-on:click="menuHandler">
                    <li><a href="#" v-on:click="view_terms=true;">Privacidade</a></li>
                    <li><router-link :to="{ name:'avatar' }">Avatar</router-link></li>
                    <li><router-link :to="{ name:'ranking' }">Ranking</router-link></li>
                    <!-- <li><router-link :to="{ name:'jogo' }">Jogar</router-link></li> -->
                    <li><a href="#" v-on:click="infoComoJogar">Como jogar</a></li>
                    <!--<li><a href="#" v-on:click="info">Minhas Missões</a></li>-->
                    <li><a href="#" v-on:click="view_mission=true">Minhas Missões</a></li>
                    <li v-if="$route.name === 'jogo'"><a href="#" v-on:click="itemInfoView">Inventário de Objetivos</a></li>
                    <li><a href="#" v-on:click="view_exit=true">Sair</a></li>
                </ul>
            </nav>



            <div id="user-info" ref="user-info">
                <div id="user-info-1" ref="user-info-1">
                    <img :src="$url + 'img/moeda.png'" width="65">{{ points ? points : 0 }}
                </div>
                <!-- <div id="user-info-2" ref="user-info-2">###</div> -->
            </div>


            

            <audio v-if="(($route.name === 'entrar') || ($route.name === 'avatar'))" id="trilha_0" autoplay loop>
                <source :src="$url + 'audio/trilha_1.mp3'" type="audio/mpeg">
                Your browser does not support the audio element.
            </audio>



        </header>
        <router-view/>
        <MultiplayerComponent v-if="logged" ref="multiplayer"></MultiplayerComponent>
        <ExitComponent v-if="logged && view_exit"></ExitComponent>
        <ItemComponent v-if="logged && view_item"></ItemComponent>
        <InfoDesktopComponent v-if="logged && view_info_desktop"></InfoDesktopComponent>
        <InfoMobileComponent v-if="logged && view_info_mobile"></InfoMobileComponent>
        <TermsComponent v-if="view_terms"></TermsComponent>
        <ItemInfoComponent v-show="view_item_info" ref="item-info"></ItemInfoComponent>
        <VideoComponent v-show="view_video" ref="item-info"></VideoComponent>
        <Bonus v-if="view_bonus" ref="bonus"></Bonus>
        <InitInfoComponent v-show="view_init" ref="item-info"></InitInfoComponent>
        <MissionComponent v-show="view_mission" ref="item-info"></MissionComponent>
        <InfoFailComponent v-if="view_fail"></InfoFailComponent>

        <div v-if="($route.name === 'jogo')" id="audio-controller" v-on:click="audioControllerHandler">
            <img id="audio-controller-img" :src="$url + 'img/audio.png'" width="44">
        </div>


    </div>
</template>
<script>
    import { mapActions, mapGetters } from "vuex";
    import MultiplayerComponent from '@/components/MultiplayerComponent';
    import ExitComponent from '@/components/ExitComponent';
    import ItemComponent from '@/components/ItemComponent';
    import InfoDesktopComponent from '@/components/InfoDesktopComponent';
    import InfoMobileComponent from '@/components/InfoMobileComponent';
    import TermsComponent from '@/components/TermsComponent';
    import ItemInfoComponent from '@/components/ItemInfoComponent';
    import VideoComponent from '@/components/VideoComponent';
    import InitInfoComponent from '@/components/InitInfoComponent';
    import MissionComponent from '@/components/MissionComponent';
    import InfoFailComponent from '@/components/InfoFailComponent';
    import Bonus from '@/components/Bonus';
    import { isMobile } from 'mobile-device-detect';
    import axios from "axios";
    export default {
        name: "App",
        data() {
            return {
                end: false,
                menu_active: false,
                menu_info: "",
                next_level: false,
                user: null,
                version: 4,
                view_exit: false,
                view_item: false,
                view_info_desktop: false,
                view_info_mobile: false,
                view_terms: false,
                view_item_info: false,
                view_video: false,
                view_bonus: false,
                view_init: false,
                view_mission: false,
                view_fail: false
            }
        },
        components: {
           MultiplayerComponent, ExitComponent, ItemComponent, InfoDesktopComponent, InfoMobileComponent, TermsComponent, ItemInfoComponent, VideoComponent, Bonus, InitInfoComponent, MissionComponent, InfoFailComponent
        },
        computed: {
            ...mapGetters(['token', 'logged', 'id', 'name', 'email', 'points', 'started', 'player', 'avatar', 'mobile', 'itens_count_day'])
        },
        methods: {
            audioControllerHandler(e) {
                document.getElementById('trilha').muted = document.getElementById('trilha').muted ? false : true;
                document.getElementById('audio-controller-img').src = (document.getElementById('trilha').muted ? (this.$url + 'img/audio_no.png') : (this.$url + 'img/audio.png'));

                this.focusGame();
                
                e.preventDefault();
            },
            ...mapActions(['update', 'update_profile', 'increment', 'update_started', 'update_avatar', 'update_mobile', 'update_points']),
            saveUser(user_) {
                this.user = user_;
                const parsed = JSON.stringify(this.user);
                localStorage.setItem('user', parsed);
                this.update(user_.token);
                this.update_profile(user_);
                this.update_avatar(user_.avatar);

                this.menu_info = user_.name ? user_.name.split(" ")[0] : "";
                this.menu_active = false;
            },


            info(e) {
                e.preventDefault();

                if (!this.mobile)
                    this.view_info_desktop = true;
                else
                    this.view_info_mobile = true;
            },



            menuHandler(e)
            {
                //console.log('menuHandler');
                if (e)
                e.currentTarget.classList.toggle("change");
                this.menu_active = !this.menu_active;
                this.menu_info = this.menu_active ? "Fechar" : this.name.split(" ")[0];
            },

            //----- savePoints -----//
            savePoints(index, points) {
                let form_data = new FormData();
                form_data.append('id_user', this.id);
                form_data.append('item', index);
                form_data.append('points', points);
                axios.post(this.$b + 'api/points', form_data).then(response => this.savePointsResponse(response));
            },
            savePointsResponse(obj) {

                if (Number(this.version) !== Number(obj.data.version)) {
                    window.location.href = '';
                } else {

                    this.user.points = Number(this.points) + Number(obj.data.points);
                    const parsed = JSON.stringify(this.user);
                    localStorage.setItem('user', parsed);

                    this.increment(obj.data.points);
                    
                    //console.log('App pontuou -> ', this.points, this.itens_count_day, obj.data.version);
                    //bonus
                    //if ((this.points > 0) && (this.itens_count_day == 30) && ((this.points % 300) == 0)) {
                    if ((!this.next_level) && (this.points > 0) && (this.itens_count_day == 30)) {
                        this.next_level = true;
                        this.view_bonus = true;
                        this.savePoints(-1, 100);
                    }
                    //if ((this.points > 0) && (this.itens_count_day == 50) && ((this.points % 800) == 0)) {
                    if ((!this.end) && (this.points > 0) && (this.itens_count_day == 50)) {
                        this.end = true;
                        this.view_bonus = true;
                        this.savePoints(-1, 200);
                    }
                    //
                }
            },
            //----- \savePoints\ -----//



            //----- exit -----//
            gameDestroy() {
                for (let o in this.$children) {
                    if (this.$children[o].$el.id === 'game-component') {
                        this.$children[o].exit();
                        break;
                    }
                }
            },
            exit() {
                if (this.$route.name === 'jogo')
                    this.gameDestroy();
                
                localStorage.setItem('user', null);
                this.update(null);
                this.update_profile(null);
                if (this.$route.name !== 'home')
                    this.$router.push('/');
            },
            //----- \exit\ -----//


            focusGame() {
                for (let o in this.$children) {
                    if (this.$children[o].$el.id === 'game-component') {
                        //console.log('game focus');
                        this.$children[o].$refs['game'].focus();
                        break;
                    }
                }
            },

            //----- item-info -----//
            itemInfoView(e) {
                //root_.$parent.itemInfo(root_.itens_listener, root_.total_itens);

                if (this.$route.name === 'jogo') {
                    this.$forceUpdate();
                    for (let o in this.$children) {
                        if (this.$children[o].$el.id === 'game-component') {
                            this.$children[o].$refs['game'].focus();
                            this.itemInfo(this.$children[o].itens_listener, this.$children[o].total_itens);
                            break;
                        }
                    }
                }

                
                e.preventDefault();
            },
            itemInfo(itens, total_itens) {
                //console.log('aqui meu amigo');
                
                if (this.$route.name === 'jogo') {
                    for (let o in this.$children) {
                        if (this.$children[o].$el.id === 'item-info-component') {
                            this.$children[o].start(itens, total_itens);
                            break;
                        }
                    }
                }
            },
            videoInfo(itens, total_itens) {
                if (this.$route.name === 'jogo') {
                    for (let o in this.$children) {
                        if (this.$children[o].$el.id === 'video-component') {
                            this.$children[o].start(itens, total_itens);
                            break;
                        }
                    }
                }
            },
            //----- -----//

            loadPointsResponse(obj) {
                
                this.user.points = Number(obj.data.points);
                const parsed = JSON.stringify(this.user);
                localStorage.setItem('user', parsed);

                this.update_points(Number(obj.data.points));
            },

            infoComoJogar(e) {

                if (isMobile)
                    this.view_info_mobile = true;
                else
                    this.view_info_desktop = true;
                e.preventDefault();
            }

        },
        created() {
            
            //----- user session -----//
            if (localStorage.getItem('user')) {
                try {
                    this.user = JSON.parse(localStorage.getItem('user'));
                    this.saveUser(this.user);


                    let form_data = new FormData();
                    form_data.append('id_user', this.id);
                    axios.get(this.$b + 'api/get-points?' + new URLSearchParams(form_data).toString()).then(response => this.loadPointsResponse(response));

                } catch(e) {
                    localStorage.removeItem('user');
                }
            }
            for (let o in this.$router.options.routes) {
                if ((!this.logged) && (this.$route.name === this.$router.options.routes[o].name) && (this.$router.options.routes[o].meta.requiresLogin)) {
                    this.$router.push('/entrar');
                    break;
                } else if ((this.logged) && ((this.$route.name === 'home') ||(this.$route.name === 'entrar') || (this.$route.name === 'cadastro'))) {
                    this.$router.push('/jogo');
                    break;
                }
            }
            this.update_started(true);
            //----- \user session\ -----//

        },
        mounted() {
            this.update_mobile(isMobile ? true : false);
            this.menu_info = this.name ? this.name.split(" ")[0] : "";
        }
    }
</script>

<style>
@import "assets/css/core.css";
@import "assets/css/header.css";
@import "assets/css/form.css";
html, body
{
    overflow-x: hidden;
}


#app {
    background-color: #fff;
}
#logo {
    box-sizing: border-box;
    height: auto;
    padding: 20px 15px 15px 15px;
    width: 150px;
}
#points {
    background-color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 10px;
    position: absolute;
    right: 100px;
    top: 10px;
}
#audio-controller {
    background-color: rgba(255, 255, 255, .4);
    border-radius: 50%;
    box-sizing: border-box;
    height: 64px;
    top: 85px;
    left: 10px;
    padding: 10px;
    position: fixed;
    width: 64px;
    z-index: 99999;
}
</style>